import { BaseSchema, BlazeTableSchema } from '@blaze-shared/schema-domain';
import { Connection, ExceptWorkflowNode, Workflow } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('Except')
export class ExceptNodeSchemaProvider extends SchemaProvider<ExceptWorkflowNode> {
  override getSchemas(
    workflow: Workflow,
    node: ExceptWorkflowNode,
    schemas: {
      input: Map<string | symbol, BaseSchema>;
      output: Map<string | symbol, BaseSchema>;
      allSchemas: Record<string, BaseSchema>;
      userSchema?: BlazeTableSchema | null;
      accountSchema?: BlazeTableSchema | null;
    },
    connections: Connection[],
  ): Map<string | symbol, BaseSchema> {
    const nodeSchemas = super.getSchemas(workflow, node, schemas, connections);
    const targetNode = workflow.nodes.find((n) => n.id === node.targetNodeId);

    const input2Schema = targetNode ? schemas.output.get(targetNode.id) : null;
    if (input2Schema) {
      nodeSchemas.set('input2', input2Schema);
    }

    return nodeSchemas;
  }
}
